var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "item pb-3 mb-5 border-bottom",
      attrs: { id: "About--" + _vm.merchant.id }
    },
    [
      _vm.fetchingData
        ? _c("loader")
        : _c(
            "div",
            [
              _c(
                "transition",
                { attrs: { mode: "out-in", name: "slide" } },
                [
                  !_vm.isEdit
                    ? _c(
                        "div",
                        { staticClass: "no-gutters" },
                        [
                          _c("div", { staticClass: "col-12" }, [
                            _c("h2", [_vm._v(_vm._s(_vm.merchant.headline))])
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("p", {
                              staticClass: "col-12",
                              domProps: {
                                innerHTML: _vm._s(_vm.merchant.description)
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("buttons", {
                            attrs: {
                              disableDelete: true,
                              isLoading: _vm.submitting
                            },
                            on: {
                              edit: function($event) {
                                _vm.isEdit = true
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isEdit
                    ? _c("buero-form", {
                        attrs: {
                          elementValues: this.merchant,
                          schema: _vm.schema,
                          method: "patch",
                          url: "/api/merchant/about"
                        },
                        on: {
                          cancel: _vm.cancelEdit,
                          updateItem: _vm.updateItem
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }